import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createEventExpenseService, type CreateEventExpensePayload } from '@/services/events'
import { eventDetailsQueryKey } from './useEventDetails'

export const useCreateEventExpense = (agendaId: string, eventId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: CreateEventExpensePayload) =>
      createEventExpenseService(agendaId, eventId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: eventDetailsQueryKey(agendaId, eventId) })
    },
  })
}
